'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _transparentize = require('polished/lib/color/transparentize');

var _transparentize2 = _interopRequireDefault(_transparentize);

var _config = require('../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Link = function Link(options) {
  var defaults = {
    type: 'base'
  };
  var settings = _extends({}, defaults, options);
  var links = {
    base: '\n      text-decoration: none;\n\n      &:hover {\n        text-decoration: none;\n      }\n    ',
    black: '\n      box-shadow: 0 1px 0px 0px ' + (0, _transparentize2.default)(0.8, _config.colors.black) + ';\n      color: ' + _config.colors.black + ';\n\n      &::before {\n        color: ' + _config.colors.black + ';\n      }\n    ',
    white: '\n      box-shadow: 0 1px 0px 0px ' + (0, _transparentize2.default)(0.8, _config.colors.white) + ';\n      color: ' + _config.colors.white + ';\n\n      &::before {\n        color: ' + _config.colors.white + ';\n      }\n    ',
    red: '\n      box-shadow: 0 1px 0px 0px ' + (0, _transparentize2.default)(0.8, _config.colors.red) + ';\n      color: ' + _config.colors.red + ';\n\n      &::before {\n        color: ' + _config.colors.red + ';\n      }\n    ',
    blue: '\n      box-shadow: 0 1px 0px 0px ' + (0, _transparentize2.default)(0.8, _config.colors.darkBlue) + ';\n      color: ' + _config.colors.darkBlue + ';\n\n      &::before {\n        color: ' + _config.colors.darkBlue + ';\n      }\n    ',
    bold: '\n      font-weight: 700;\n    '
  };

  return links[settings.type];
};

exports.default = Link;